import React from "react";
import HighlightOff from "@material-ui/icons/HighlightOff";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { useSegment } from "analytics/segment";
import { useStore as useAuthStore } from "auth/store";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { useUpdateQaEmailConfigurations } from "core/queries/UpdateQAEmailConfigurations";
import { DispatchRoleName } from "typings/globalGQLTypes";

interface RemoveQualityAuditConfigurationButtonProps {
  userId?: string;
  companyId?: string;
}
export const RemoveQualityAuditConfigurationButton = ({
  userId,
  companyId,
}: RemoveQualityAuditConfigurationButtonProps) => {
  const { state: authState } = useAuthStore();
  const errorReporter = useErrorReporterFiltered();
  const { track } = useSegment();

  const variables = {
    userId: userId || "",
    removedCompanyIds: companyId ? [companyId] : [],
  };

  const [updateQaEmailConfiguration] = useUpdateQaEmailConfigurations({
    awaitRefetchQueries: true,
    refetchQueries: ["GetQAEmailConfigurations"],
    variables,
  });

  const cityId = authState.user?.cityId;
  const roles = authState.user?.roles || [];
  if (!cityId || !roles.includes(DispatchRoleName.tom_manager)) return null;

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    track({
      eventName: "qa_email_configuration_user_row",
      action: "click",
      element: "remove_qa_email_configuration",
      props: { userId },
    });
    updateQaEmailConfiguration()
      .then(() => {})
      .catch(error => {
        errorReporter.notify(error);
      });
  };

  return (
    <CircleButton
      backgroundVariant="light"
      title="Remove user from QA Email List"
      onClick={onClick}
    >
      <HighlightOff />
    </CircleButton>
  );
};
